class CurrencyService {
    ToDollars(value: number): string {
      return Number((value).toFixed(2)).toLocaleString(
        undefined,
        { minimumFractionDigits: 2 }).replace(',','.') + '$'
    }  
  }
  
  export default new CurrencyService();
  